export enum rootPaths {
  INDEX = "/",
  MAIN = "/main",
  DEVELOPER = "/developer",
}
